import Form from '../../components/Form'
import { useTheme } from '../../hooks/useTheme'

// styles
import './Contact.css'

export default function Contact() {
    const { mode } = useTheme()

    return (
        <div className={`layout ${mode}`}>
            <h1>Contact Me</h1>
            <Form />
        </div>
    )
}